import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Notificacion, tipoNotificacion } from '@app/shared/interfaces/notification.interface';

@Component({
  selector: 'app-notifications-panel',
  standalone: false,
  templateUrl: './notifications-panel.component.html',
  styleUrl: './notifications-panel.scss'
})
export class NotificationsPanelComponent {
  constructor(private router: Router) {}

  @Input() notificaciones: Notificacion[] = [];
  @Output() onMarcarLeida = new EventEmitter<Notificacion>();
  @Output() onMarcarTodasLeidas = new EventEmitter<void>();
  @Output() onVerTodas = new EventEmitter<void>();

  // Máximo de notificaciones visibles en el panel del header (se ve todo en "Ver todas")
  private readonly MAX_VISIBLES = 5;

  get notificacionesLimitadas(): Notificacion[] {
    return this.notificaciones.slice(0, this.MAX_VISIBLES);
  }

  get noLeidas(): number {
    return this.notificaciones.filter((n) => !n.visto).length;
  }

  /** Emite la notificación tal cual está; el padre decide qué endpoint llamar según su estado actual. */
  marcarComoLeida(notif: Notificacion): void {
    this.onMarcarLeida.emit(notif);
  }

  marcarTodasLeidas(): void {
    this.notificaciones.forEach((n) => (n.visto = true));
    this.onMarcarTodasLeidas.emit();
  }

  verTodas(): void {
    this.onVerTodas.emit();
    this.router.navigate(['/notificaciones']);
  }

  private static readonly ICONOS: Record<tipoNotificacion, string> = {
    message: 'pi pi-comment',
    alert: 'pi pi-exclamation-triangle',
    update: 'pi pi-sync',
    system: 'pi pi-cog'
  };

  private static readonly COLORES: Record<tipoNotificacion, string> = {
    message: 'notif-icon--message',
    alert: 'notif-icon--alert',
    update: 'notif-icon--update',
    system: 'notif-icon--system'
  };

  tipoIcono(tipo: tipoNotificacion): string {
    return NotificationsPanelComponent.ICONOS[tipo] ?? 'pi pi-bell';
  }

  tipoColorClass(tipo: tipoNotificacion): string {
    return NotificationsPanelComponent.COLORES[tipo] ?? 'notif-icon--system';
  }
}
